<template>
  <bimPopup v-model="openPopup" title="Встроить список моделей на сайт" width="600px">
    <div style="width: 500px">
      <bimTextarea width="100%" placeholder="Встроить модели на сайт" v-model="embedCode"></bimTextarea>
    </div>
  </bimPopup>
</template>

<script>
import bimPopup from '@bimlib/components/bimPopup'
import bimTextarea from '@bimlib/components/bimTextarea'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'EmbedModelsModal',
  components: {
    bimPopup,
    bimTextarea
  },
  data () {
    return {
      openPopup: false,
      embedCode: 'embedCode'
    }
  },
  computed: mapState({
    gridType (state) {
      return state.modelsFilter.gridType
    }
  }),
  mounted () {
    document.addEventListener('keydown', e => {
      if (e.ctrlKey && e.code === 'KeyJ') {
        this.openPopup = !this.openPopup
        this.formEmbedCode()
      }
    })
  },
  methods: {
    ...mapActions([
      'formModelsQueryParams'
    ]),

    async formEmbedCode () {
      const host = window.location.origin
      const type = this.gridType === 'small' ? 'card' : 'big-wide'
      let queryParams = await this.formModelsQueryParams() || ''

      if (queryParams) {
        queryParams = btoa(queryParams.toString())
      }

      this.embedCode = `<script src="${host}/dist/build/front_white/js/embed_models.js" charset="utf-8" async><\/script>\n`
        + `<div id="catalogue"><catalogue host="${host}" type="${type}" query-params="${queryParams}"></catalogue></div>`
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
